import React from 'react';
import Script from 'next/script';

export const VisitorChat: React.FC = () => {
  const src = 'https://embed.tawk.to/68625f3340edb5191650029d/1iv047o7h';

  return (
    <Script
      src={src}
      type="text/javascript"
      strategy={'afterInteractive'}
      async
    />
  );
};
